import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import Checkbox from './Checkbox';

const CheckboxGroup = ({
  disabled,
  horizontal,
  name,
  options,
  value,
  onBlur,
  onChange,
  custom,
}) => <>
    {options.map((option, idx) => {
      const { optionDisabled, id, value: optionValue, ...rest } = option;
      return (
        <Checkbox
          checked={value === optionValue}
          custom={custom}
          disabled={disabled || optionDisabled}
          horizontal={horizontal}
          id={id}
          key={`${id}-${idx}`}
          name={name}
          onBlur={onBlur}
          onChange={onChange}
          value={optionValue}
          {...rest}
        />
      );
    })}
  </>

export default CheckboxGroup;

CheckboxGroup.propTypes = {
  disabled: PropTypes.bool,
  horizontal: PropTypes.bool,
  custom: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      disabled: PropTypes.bool,
      id: PropTypes.string.isRequired,
      label: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

CheckboxGroup.defaultProps = {
  disabled: false,
  custom: false,
  horizontal: false,
  options: [],
};
